export const ItemSpriteIds = {
    thruster: {
        icon: '', 
        staticOverlay: '',
        activeOverlay: 'thruster'
    },
    pick: {
        icon: '',
        staticOverlay: 'pick_s',
        activeOverlay: 'pick_a'
    },
    club: {
        icon: '',
        staticOverlay: 'club_s',
        activeOverlay: 'club_a'
    },
    axe: {
        icon: '',
        staticOverlay: 'axe_s',
        activeOverlay: 'axe_a'
    },
    broadSword: {
        icon: '',
        staticOverlay: 'broad_sword_s',
        activeOverlay: 'broad_sword_a'
    },
    mace: {
        icon: '',
        staticOverlay: 'mace_s',
        activeOverlay: 'mace_a'
    },
    twoHandedAxe: {
        icon: '',
        staticOverlay: 'two_handed_axe_s',
        activeOverlay: 'two_handed_axe_a'
    },
    twoHandedClub: {
        icon: '',
        staticOverlay: 'two_handed_club_s',
        activeOverlay: 'two_handed_club_a'
    },
    darkSword: {
        icon: '',
        staticOverlay: 'dark_sword_s',
        activeOverlay: 'dark_sword_a'
    },
    redSword: {
        icon: '',
        staticOverlay: 'red_sword_s',
        activeOverlay: 'red_sword_a'
    },
};